"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import SmartInbox from "@/components/admin/SmartInbox";
import AdminNotes from "@/components/admin/AdminNotes";
import { ADMIN_NAV_ITEMS } from "@/config/adminNav";

// Phase 2: Smart Inbox Dashboard. Answers "what needs my attention today?"
// via /api/admin/smart-tasks (30s cache) and shows a secondary chip row of
// most-used sections for fast navigation without leaving the dashboard.

const PRIMARY_NAV_IDS = [
  "upload",
  "artworks",
  "visibility",
  "orders",
  "sticker-orders",
  "content",
  "trash",
];

export default function AdminDashboard() {
  const [now] = useState(() => new Date());
  const [tasks, setTasks] = useState(null);
  const [weeklyRevenue, setWeeklyRevenue] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await fetch("/api/admin/smart-tasks", {
          cache: "no-store",
        });
        if (!res.ok) {
          if (!cancelled) setError(`載入失敗（${res.status}）`);
          return;
        }
        const body = await res.json();
        if (cancelled) return;
        setTasks(body.tasks ?? []);
        setWeeklyRevenue(body.weeklyRevenue ?? 0);
      } catch {
        if (!cancelled) setError("載入失敗，請重試");
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const primaryLinks = ADMIN_NAV_ITEMS.filter((n) =>
    PRIMARY_NAV_IDS.includes(n.id),
  );

  return (
    <main className="admin-dashboard">
      <SmartInbox
        now={now}
        tasks={tasks}
        weeklyRevenue={weeklyRevenue}
        error={error}
      />

      <section
        className="admin-dashboard__quicklinks"
        aria-labelledby="quicklinks-heading"
      >
        <h2 id="quicklinks-heading" className="admin-dashboard__h2">
          常用入口
        </h2>
        <ul className="admin-dashboard__chip-row">
          {primaryLinks.map((item) => (
            <li key={item.id}>
              <Link href={item.href} className="admin-dashboard__chip">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <AdminNotes />
    </main>
  );
}
